module.exports = __webpack_public_path__ + "static/media/FedEx_logo.0ce275b3.jpg";